export const hostVersion = "2.0.2";
